import { FullUser } from "authentication/domain/FullUser";
import { useEffect, useState } from "react";
import userImg from "../images/user.jpg";
import LoginsPopover from "./LoginsPopover";
import { authServices } from "authentication/services/auth.service";
import Popover from "components/Popover/Popover";
import { useAppDispatch } from "hooks/hooks";
import {
  getMyLogins,
  selectState,
  setLoginsPopover
} from "Dashboard/login.slice";
import { useSelector } from "react-redux";
import InfoTooltip from "components/Popup/InfoTooltip";
import { ISession } from "authentication/domain/ISession";
import ActiveSession from "./ActiveSession";
import { BsFillPeopleFill } from "react-icons/bs";

interface IProps {
  user: FullUser;
};

const LoginPanel = (props: IProps) => {
  let { user } = props;
  const dispatch = useAppDispatch();
  const { loginsPopover, myLogins } = useSelector(selectState);
  const [activeSessions, setActiveSessions] = useState<ISession[]>();
  const [img, setImg] = useState<string | null>(null);

  const getActiveSessions = async () => {
    try {
      const users = await authServices.getCurrentlyActiveSessions();
      setActiveSessions(users);
    } catch (error) {
      console.log(error);
    }
  };

  function fulfilRest(rest: number) {
    if (user.username !== undefined) {
      rest++;
    }
    return ([...Array(rest)].map((item, index) =>
      <div className="item" key={index} />
    ));
  };

  useEffect(() => {
    dispatch(getMyLogins());
  }, [dispatch]);

  useEffect(() => {
    async function getLogo() {
      try {
        const img = await authServices.getMyProfilePicture();
        setImg(img);
      } catch (error) {
        console.log(error);
      }
    }
    getActiveSessions();
    getLogo();
  }, []);

  return (
    <div className="login-panel">
      <InfoTooltip tooltip="Logovanja" element="span">
        <button className="logins-btn" onClick={(e) => {
          dispatch(setLoginsPopover({ isOpen: true, top: e.clientY, left: e.clientX }))
        }}>
          <BsFillPeopleFill />
        </button>
      </InfoTooltip>
      <div className="users-main">
        <img src={img ? img : userImg} alt="img" />
        <div>Prijavljen :: {user.username}</div>
      </div>
      <div className="users-list">
        {activeSessions?.map((activeSession, index) =>
          activeSession.username !== user?.username
          && <ActiveSession
            key={activeSession.username}
            activeSession={activeSession} />
        )}
        {activeSessions &&
          (activeSessions?.length < 5 && fulfilRest(5 - activeSessions?.length))}
      </div>
      <Popover
        isOpen={loginsPopover.isOpen}
        onClose={() => dispatch(setLoginsPopover({ isOpen: false }))}
        title="Logovanja"
        direction="right"
        arrowStyle={{ top: "50%" }}
        position={{
          top: 180, left: 720
        }}
      >
        <LoginsPopover logins={myLogins} />
      </Popover>
    </div>
  );
};

export default LoginPanel;
